<div class="preloader" *ngIf="isLoading"  >
    <div class="loader-container" >
        <div class="glow"></div>

        <div class="spade"><img src="assets/siteImg/sitelogo.svg" alt="logo1" fetchpriority="high" decoding="async" height="55" width="55">
            </div>

        <div class="orbit orbit-1">
            <div class="orbit-star"></div>
            <div class="orbit-star"></div>
            <div class="orbit-star"></div>
            <div class="orbit-star"></div>
        </div>

        <div class="orbit orbit-2">
            <div class="orbit-star"></div>
            <div class="orbit-star"></div>
            <div class="orbit-star"></div>
            <div class="orbit-star"></div>
        </div>

        <div class="orbit orbit-3">
            <div class="orbit-star"></div>
            <div class="orbit-star"></div>
            <div class="orbit-star"></div>
            <div class="orbit-star"></div>
        </div>

        <div class="orbit orbit-4">
            <div class="orbit-star"></div>
            <div class="orbit-star"></div>
            <div class="orbit-star"></div>
            <div class="orbit-star"></div>
        </div>
    </div>
    <br>
    <!-- <img src="assets/siteImg/sitelogo.svg" alt="logo" width="350" height="50" fetchpriority="high"   decoding="async"/> -->
</div>
<div class="preloader" [class.position]="isGameLaunch" *ngIf="isGameLaunch"  >
    <div class="loader-container"  >
        <div class="glow"></div>

        <div class="spade"><img src="../../../assets/siteImg/sitelogo.svg" alt="logo2" fetchpriority="high" decoding="async" height="55" width="55">
           </div>

        <div class="orbit orbit-1">
            <div class="orbit-star"></div>
            <div class="orbit-star"></div>
            <div class="orbit-star"></div>
            <div class="orbit-star"></div>
        </div>

        <div class="orbit orbit-2">
            <div class="orbit-star"></div>
            <div class="orbit-star"></div>
            <div class="orbit-star"></div>
            <div class="orbit-star"></div>
        </div>

        <div class="orbit orbit-3">
            <div class="orbit-star"></div>
            <div class="orbit-star"></div>
            <div class="orbit-star"></div>
            <div class="orbit-star"></div>
        </div>

        <div class="orbit orbit-4">
            <div class="orbit-star"></div>
            <div class="orbit-star"></div>
            <div class="orbit-star"></div>
            <div class="orbit-star"></div>
        </div>
    </div>
    <br>
    <!-- <img src="assets/siteImg/sitelogo.svg" alt="logo" width="350" height="50" fetchpriority="high"   decoding="async"> -->
</div>